/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Body from "../../components/Body";
import api from "../../config/api";
import TableMenu from "../../components/TableMenu";
import { BiCheckCircle, BiPlus } from "react-icons/bi";
import Table from "../../common/Table";
import useJob from "../../hooks/useJob";
import moment from "moment";
import AppButton from "../../common/AppButton";
import { cloneDeep } from "lodash";
import useHeader from "../../hooks/useHeader";
import { observer } from "mobx-react-lite";
import AppModal from "../../common/AppModal";
import { FaEye } from "react-icons/fa";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getJobsGroupedByOrganization } from "../../stores/JobStore";

const header = [
  { name: "jobId", title: "Job ID", filter: "Search" },
  // { name: "paymentStatus", title: "Process" },
  { name: "processStatus", title: "Payment" },
  // { name: "jobStatus", title: "Job" },
  { name: "start", title: "Start" },
  { name: "end", title: "End" },
];

const LIMIT = 100;
function OrganizationView() {
  const location = useLocation();
  const params = useParams();

  const [loadingMore, setLoadingMore] = useState(false);
  const [init] = useState(location.state.data);
  const { setHeader } = useHeader();
  const jb = useJob();
  const [model, setModel] = useState({});
  const navigate = useNavigate();
  const [skip, setSkip] = useState(LIMIT);

  const { data, refetch } = useQuery({
    queryFn: () =>
      getJobsGroupedByOrganization({
        groupBy_id: params.organization_id,
        limit: skip,
      }),
    queryKey: ["jobs", "groupedByOrganization", params.organization_id, LIMIT],
  });

  const handleCreateJob = () => {
    navigate(`/organizations/view/${params.organization_id}/createJob`, {
      state: { data: cloneDeep(init) },
    });
  };

  useEffect(() => {
    setHeader(init?.name);
  }, []);

  const handleLoadMore = async () => {
    setLoadingMore(true);
    setSkip(skip + LIMIT);
  };

  useEffect(() => {
    refetch();
    setLoadingMore(false);
  }, [skip]);

  const onJobClick = (job) => {
    delete job.processStatus;
    delete job.paymentStatus;
    delete job.jobStatus;
    console.log(job);
    navigate(`/organizations/view/${params.organization_id}/jobs/${job._id}`, {
      state: { data: { ...cloneDeep(job), organizationName: init.name } },
    });
  };

  return (
    <div>
      <Body noPadding>
        <div style={{ width: "100%" }}>
          <TableMenu>
            <AppButton
              tooltip="Create Job"
              onClick={handleCreateJob}
              leftIcon={<BiPlus size={35} />}
              className="btn"
            />
            {/* <AppButton
            onClick={handleCreateJob}
            text="Create Job"
            className="text-primary btn-light"
          /> */}
          </TableMenu>

          <Table
            header={header}
            data={
              data?.map((job, ind) => {
                const processStatus = jb.processStatus({ job });
                return {
                  ...job,
                  start: moment(jb.start({ job })).format("DD/MM/YYYY"),
                  end: moment(jb.end({ job })).format("DD/MM/YYYY"),
                  processStatus: (
                    <span style={{ alignItems: "center", gap: 5 }}>
                      {processStatus === "Completed" && (
                        <BiCheckCircle
                          size={20}
                          color={"green"}
                          style={{ marginRight: 5 }}
                        />
                      )}
                      {processStatus}
                    </span>
                  ),
                };
              }) || []
            }
            SideButtons={({ inv }) => {
              return (
                <div className="side-button" style={{ marginRight: 20 }}>
                  <AppButton
                    tooltip="View"
                    onClick={() => onJobClick(inv)}
                    leftIcon={<FaEye size={22} />}
                    className="text-primary btn-light"
                  />
                </div>
              );
            }}
          />
          <AppModal
            {...model}
            onHide={() => {
              setModel({});
            }}
          />
        </div>
      </Body>
      {data?.length > 0 && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 20,
          }}
        >
          <AppButton
            onClick={handleLoadMore}
            text="Load more..."
            className="btn-secondary"
            disabled={loadingMore}
          />
        </div>
      )}
    </div>
  );
}
export default observer(OrganizationView);
